import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ConsentDataObject } from 'models/service';

type ConsentsRequest = {
  consent_ids?: string[];
};

export const getConsents = async (params?: ConsentsRequest) =>
  apiClient.get<ConsentDataObject[], ApiClientResponse<ConsentDataObject[]>>(routes.consents.find, { params });
